import { Box } from '@mui/material';
import { FieldProps, TextField } from 'framework/ui/field';
import { DataGridLayout, List } from 'framework/list';
import { useContextHelper } from 'framework/utils';

const formattedTextTableSx = {
  '& td span': {
    whiteSpace: 'pre-wrap',
  },
  '& .th-normal': {
    minWidth: '100px !important',
  },
};

const deliveryStatusSx = {
  delivered: {
    fontStyle: 'italic',
    color: 'text.secondary',
  },
  undelivered: {
    fontStyle: 'italic',
    color: 'error.main',
  },
} as const;

interface TicketsListFieldProps extends FieldProps<string[]> {
  isDemoTickets?: boolean;
  deliveryStatus?: keyof typeof deliveryStatusSx;
}

const TicketsListField = ({ label, source, isDemoTickets = false, deliveryStatus }: TicketsListFieldProps) => {
  const { getFromAnyContext } = useContextHelper();
  const tickets = getFromAnyContext(source!);
  const getWorkItemsData = async () => {
    return Promise.resolve({ result: tickets });
  };

  const listOfTickets = isDemoTickets ? (
    <>
      <Box sx={deliveryStatus ? deliveryStatusSx[deliveryStatus] : undefined}>
        <TextField source="" value=" " label={label} />
      </Box>
      <List getDataMethod={getWorkItemsData}>
        <DataGridLayout isSmallTable sxTableWrapper={formattedTextTableSx}>
          <TextField source="ticketName" label="Work item (name or link)" width={200} />
          <TextField source="assigneeName" label="Assignee" width={150} />
          <TextField source="customerFeedback" label="Customer feedback" width={450} />
          <TextField source="comments" label="Comments" />
        </DataGridLayout>
      </List>
    </>
  ) : (
    <>
      <TextField source="" value=" " label={label} />
      <List getDataMethod={getWorkItemsData}>
        <DataGridLayout isSmallTable sxTableWrapper={formattedTextTableSx}>
          <TextField source="ticketName" label="Work item (name or link)" width={400} />
          <TextField source="assigneeName" label="Assignee" />
        </DataGridLayout>
      </List>
    </>
  );

  return tickets.length > 0 ? listOfTickets : <></>;
};

export default TicketsListField;
